/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query RateReadQuery($type: CUSTOMER_TYPE, $search: String, $filter: JSONObject, $take: PositiveInt, $skip: Int) {
    RateRead(type: $type, search: $search, filter:$filter, take: $take, skip: $skip) {
      id,
      createdAt,
      updatedAt,
      displayName,
      type,
      message,
      status,
      _totalCount,
      Account {
        email
        displayName
      }
    }
  }
`
